import show from './show';
import hide from './hide';

// ----------------------------------------------------------------------------

function toggle(element: HTMLElement, value?: boolean): boolean {
    // If using value
    if (typeof value === 'boolean') {
        if (value) {
            show(element);
        } else {
            hide(element);
        }
    } else if (element.style.display === 'none') {
        show(element);
    } else if (element.style.display === '') {
        hide(element);
    }
    return element.style.display === '';
}

// ----------------------------------------------------------------------------

export default toggle;
